import {Conversation} from '@stripe-internal/conversations-client';
import {useSyncConversationObservable} from '../helpers/useSyncConversationObservable';

export function useConversationLogItems(conversation: Conversation) {
  return useSyncConversationObservable(conversation.log);
}
